jQuery(document).ready(function(){
	jQuery('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4').click(function(){
		jQuery(this).toggleClass('open');
	});
});
